import React, { useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useHistory, useLocation } from "react-router-dom";

import styles from "./Sidebar.module.scss";

// assets
import Logo from "src/assets/images/logo/logo.svg";

// context
import { AdminAuthContext } from "src/context/AdminAuthContext";

// icons
import { AiFillHome } from "react-icons/ai";
import { IoStatsChartSharp } from "react-icons/io5";
import { MdPowerSettingsNew } from "react-icons/md";

const Sidebar = ({ isOpen }) => {
  const { logout } = useContext(AdminAuthContext);

  const location = useLocation();
  const history = useHistory();

  const list = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delay: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, x: -50 },
    show: { opacity: 1, x: 0 },
  };

  const isActive = (_pathname) => {
    return _pathname === location.pathname;
  };

  const handleLogout = async () => {
    try {
      await logout();
      history.push("/admin-login");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={styles.sidebar__wrapper}
        >
          <motion.div className={styles.head}>
            <img src={Logo} alt="eventmoon" />
            <div className={styles.divider} />
          </motion.div>
          <motion.ul
            variants={list}
            initial="hidden"
            animate="show"
            className={styles.list}
          >
            <Link to="/dashboard">
              <motion.li
                variants={item}
                className={isActive("/dashboard") ? styles.active : ""}
              >
                <span>
                  <AiFillHome />
                </span>
                <span>Dashboard</span>
              </motion.li>
            </Link>
            <Link to="/dashboard/analytics">
              <motion.li
                variants={item}
                className={
                  isActive("/dashboard/analytics") ? styles.active : ""
                }
              >
                <span>
                  <IoStatsChartSharp />
                </span>
                <span>Analytics</span>
              </motion.li>
            </Link>
          </motion.ul>
          <div className={styles.footer}>
            <span onClick={handleLogout}>
              <MdPowerSettingsNew />
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Sidebar;
